import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SignatureContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column' as const,
  padding: theme.spacing(3),
  backgroundColor: theme.palette.background.paper,
}));
